import type { ComponentType } from "react";

// SVG flags for the language switcher. Flag emoji don't render on Windows
// (they fall back to plain two-letter text like "GB"), so real vector flags
// are used instead — same fix already applied to the footer's Moroccan flag.
const BASE = "inline-block h-3 w-[1.125rem] rounded-[2px] shadow-sm flex-shrink-0";

export function FlagGB({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" role="img" aria-label="United Kingdom" className={`${BASE} ${className}`}>
      <rect width="30" height="20" fill="#012169" />
      <path d="M0,0 L30,20 M30,0 L0,20" stroke="#fff" strokeWidth="4" />
      <path d="M0,0 L30,20 M30,0 L0,20" stroke="#C8102E" strokeWidth="1.3" />
      <path d="M15,0 V20 M0,10 H30" stroke="#fff" strokeWidth="6.6" />
      <path d="M15,0 V20 M0,10 H30" stroke="#C8102E" strokeWidth="4" />
    </svg>
  );
}

export function FlagFR({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" role="img" aria-label="France" className={`${BASE} ${className}`}>
      <rect width="10" height="20" x="0" fill="#0055A4" />
      <rect width="10" height="20" x="10" fill="#fff" />
      <rect width="10" height="20" x="20" fill="#EF4135" />
    </svg>
  );
}

export function FlagNL({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" role="img" aria-label="Nederland" className={`${BASE} ${className}`}>
      <rect width="30" height="6.67" y="0" fill="#AE1C28" />
      <rect width="30" height="6.67" y="6.67" fill="#fff" />
      <rect width="30" height="6.67" y="13.33" fill="#21468B" />
    </svg>
  );
}

export function FlagES({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" role="img" aria-label="España" className={`${BASE} ${className}`}>
      <rect width="30" height="20" fill="#AA151B" />
      <rect width="30" height="10" y="5" fill="#F1BF00" />
    </svg>
  );
}

export function FlagDE({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" role="img" aria-label="Deutschland" className={`${BASE} ${className}`}>
      <rect width="30" height="6.67" y="0" fill="#000" />
      <rect width="30" height="6.67" y="6.67" fill="#DD0000" />
      <rect width="30" height="6.67" y="13.33" fill="#FFCE00" />
    </svg>
  );
}

export function FlagIT({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" role="img" aria-label="Italia" className={`${BASE} ${className}`}>
      <rect width="10" height="20" x="0" fill="#009246" />
      <rect width="10" height="20" x="10" fill="#fff" />
      <rect width="10" height="20" x="20" fill="#CE2B37" />
    </svg>
  );
}

export function FlagPT({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" role="img" aria-label="Portugal" className={`${BASE} ${className}`}>
      <rect width="30" height="20" fill="#FF0000" />
      <rect width="12" height="20" fill="#006600" />
      <circle cx="12" cy="10" r="4" fill="#FFCC00" stroke="#fff" strokeWidth="0.5" />
    </svg>
  );
}

export function FlagMA({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" role="img" aria-label="Maroc" className={`${BASE} ${className}`}>
      <rect width="30" height="20" fill="#c1272d" />
      <path
        d="M15 5 17.94 14.05 10.24 8.45h9.52l-7.7 5.6Z"
        fill="none"
        stroke="#006233"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const FLAG_ICONS: Record<string, ComponentType<{ className?: string }>> = {
  en: FlagGB,
  fr: FlagFR,
  nl: FlagNL,
  es: FlagES,
  de: FlagDE,
  it: FlagIT,
  pt: FlagPT,
  ar: FlagMA,
};
